import { defineComponent as _defineComponent } from 'vue'
import dayjs from "dayjs";
import { ref } from "vue";
import CalendarInput from "../shared/inputs/CalendarInput.vue";
import Calendar from "../shared/Calendar.vue";

interface SelectDateEvent {
  fromDate: string;
  toDate: string;
}


const __default__ = {
  name: "DurationSelector",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  /** 과거 1개월 전 */
  defaultFromDate: {
    type: String,
    default: dayjs().subtract(1, "month").format("YYYY-MM-DD"),
  },

  /** 오늘 */
  defaultToDate: {
    type: String,
    default: dayjs().format("YYYY-MM-DD"),
  },

  /** 과거 1년 */
  minSelectableDate: {
    type: String,
    default: dayjs().subtract(1, "year").format("YYYY-MM-DD"),
  },

  /** 오늘 */
  maxSelectableDate: {
    type: String,
    default: dayjs().format("YYYY-MM-DD"),
  },
},
  emits: ["onSelectFromDate", "onSelectToDate"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;

const emit = __emit;

/** [시작 날짜] 설정 */
const searchFromDate = ref(props.defaultFromDate);
const updateSearchFromDate = (date: string) => {
  searchFromDate.value = date;
};

/** [만료 날짜] 설정 */
const searchToDate = ref(props.defaultToDate);
const updateSearchToDate = (date: string) => {
  searchToDate.value = date;
};

/** [시작 날짜] 선택 달력 보이기 여부 */
const shouldShowFromDateCalendar = ref(false);
const toggleShowFromDateCalendar = (show: boolean) => {
  shouldShowFromDateCalendar.value = show;
};

/** [만료 날짜] 선택 달력 보이기 여부 */
const shouldShowToDateCalendar = ref(false);
const toggleShowToDateCalendar = (show: boolean) => {
  shouldShowToDateCalendar.value = show;
};

/** 이벤트 바인딩 - [시작 날짜] 선택 */
const handleSelectFromDate = (date: string) => {
  const fromDay = dayjs(date);
  const endDay = dayjs(searchToDate.value);

  const newFromDate = fromDay.format("YYYY-MM-DD");

  if (fromDay > endDay) {
    updateSearchToDate(newFromDate);
  }

  updateSearchFromDate(newFromDate);
  toggleShowFromDateCalendar(false);

  emit("onSelectFromDate", {
    fromDate: searchFromDate.value,
    toDate: searchToDate.value,
  });
};

/** 이벤트 바인딩 - [만료 날짜] 선택 */
const handleSelectToDate = (date: string) => {
  const fromDay = dayjs(searchFromDate.value);
  const endDay = dayjs(date);
  const newEndDate = endDay.format("YYYY-MM-DD");

  if (fromDay > endDay) {
    const getMonthAgo = endDay.subtract(1, "month").format("YYYY-MM-DD");
    updateSearchFromDate(getMonthAgo);
  }

  updateSearchToDate(newEndDate);
  toggleShowToDateCalendar(false);

  emit("onSelectToDate", {
    fromDate: searchFromDate.value,
    toDate: searchToDate.value,
  });
};

const __returned__ = { props, emit, searchFromDate, updateSearchFromDate, searchToDate, updateSearchToDate, shouldShowFromDateCalendar, toggleShowFromDateCalendar, shouldShowToDateCalendar, toggleShowToDateCalendar, handleSelectFromDate, handleSelectToDate, CalendarInput, Calendar }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})